import { Stack, Typography } from "@mui/material";
import type { ChangeRequestChangeSet } from "../../../../../api/types/workflowTypes";
import useClientContext from "../../../../../context/useClientContext";
import { getObjectPageRoute } from "../../../../../utilities/navigationHelper";
import MemberChangesTable from "./MemberChangesTable";
import MemberContactFlagAlert from "./MemberContactFlagAlert";
import type { MemberChangeView } from "./membersChangeRequestHelper";
import { buildMemberChanges, getMemberGroupHeading, memberActionOrder } from "./membersChangeRequestHelper";

interface Props {
  changeSets: ChangeRequestChangeSet[];
  isPending: boolean;
}

const MembersChangeSetsSection = ({ changeSets, isPending }: Props) => {
  const { clientCode, hasAnyPermission } = useClientContext();

  const hasAccessToFundStructure = hasAnyPermission(["ViewFundStructure", "ManageFundStructure"]);

  const members = buildMemberChanges(changeSets);

  const groups = memberActionOrder
    .map((action) => ({ action, items: members.filter((member) => member.action === action) }))
    .filter((group) => group.items.length > 0);

  const getContactHref = (member: MemberChangeView): string | undefined =>
    member.existingContact && hasAccessToFundStructure
      ? getObjectPageRoute(clientCode, member.existingContact.contactId, "Contact")
      : undefined;

  return (
    <Stack spacing={3} sx={{ alignItems: "flex-start", width: "100%" }}>
      {groups.map(({ action, items }) => (
        <Stack key={action} spacing={2} sx={{ width: "100%" }}>
          <Typography variant="subtitle2">{getMemberGroupHeading(action, items.length)}</Typography>
          {action === "CreateNew" && isPending && <MemberContactFlagAlert members={items} />}
          <MemberChangesTable members={items} getContactHref={getContactHref} isPending={isPending} />
        </Stack>
      ))}
    </Stack>
  );
};

export default MembersChangeSetsSection;
